<script>
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
import { BOverlay } from 'bootstrap-vue'
import {
  authComputed,
  userListMethod,
  siteListMethod,
  authMethods,
} from '@state/helpers'
import countrycitystatejson from 'countrycitystatejson'
export default {
  page: {
    title: 'Update admin',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    'b-overlay': BOverlay,
  },
  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data() {
    return {
      firstName: '',
      lastName: '',
      adminError: null,
      isadminError: false,
      isLoading: false,
      show: false,
      adminId: null,
      adminSuccess: '',
      isSuccess: false,
      phone: '',
      stateList: [],
      state: null,
      cityList: [],
      city: null,
      profilePic: '',
      validTypeError: false,
      sizeError: false,
      AWSUrl: '',
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.stateList = countrycitystatejson.getStatesByShort('IN')
  },
  methods: {
    ...userListMethod,
    ...siteListMethod,
    ...authMethods,
    // save admin method
    saveProfile() {
      if (!this.sizeError && !this.validTypeError) {
        let Data = {
          id: this.currentUser.user._id,
          first_name: this.firstName,
          last_name: this.lastName,
        }

        if (this.state !== null) {
          Data.country = this.state
        }
        if (this.city !== null) {
          Data.city = this.city
        }
        if (this.profilePic !== '') {
          Data.profilePic = this.profilePic
        }
        this.updateProfile({ Data })
          .then((data) => {
            this.isLoading = false
            this.isadminError = false
            this.adminSuccess = 'Details Updated Successfully'
            this.isSuccess = true
            window.location.reload()
          })
          .catch((error) => {
            this.isLoading = false
            var getError = new ErrorWrapper(error)
            this.adminError = getError.message
            this.isadminError = true
          })
      }
    },

    resetModal() {
      this.firstName = this.data.first_name
      this.lastName = this.data.last_name
      this.phone = this.data.phone
      if (this.data.country) {
        this.state = this.data.country
        this.selectCity()
      }
      if (this.data.city) {
        this.city = this.data.city
      }
      if (this.data.profilePic) {
        this.profilePic = this.data.profilePic
      }
      this.adminError = ''
      this.isadminError = false
      this.adminSuccess = ''
      this.isSuccess = false
      this.sizeError = false
      this.validTypeError = false
    },
    getData() {
      this.AWSUrl = `${process.env.VUE_APP_AWS_URL}`
      this.firstName = this.data.first_name
      this.lastName = this.data.last_name
      this.phone = this.data.phone
      if (this.data.country) {
        this.state = this.data.country
        this.selectCity()
      }
      if (this.data.city) {
        this.city = this.data.city
      }
      if (this.data.profilePic) {
        this.profilePic = this.data.profilePic
      }
    },

    selectCity() {
      this.city = null
      this.cityList = countrycitystatejson.getCities('IN', this.state)
    },

    uploadImage: function () {
      var file = document.querySelector('input[type=file]').files[0]
      let mimeType = document.querySelector('input[type=file]').files[0].type
      if (
        mimeType === 'image/png' ||
        mimeType === 'image/jpeg' ||
        mimeType === 'image/jpg'
      ) {
        if (file.size <= 3000000) {
          this.validTypeError = false
          this.sizeError = false
          var reader = new FileReader()
          reader.readAsDataURL(file)
          reader.onload = (evt) => {
            let img = new Image()
            img.src = evt.target.result
            this.profilePic = reader.result
          }
        } else {
          this.sizeError = true
          this.validTypeError = false
        }
      } else {
        this.sizeError = false
        this.validTypeError = true
      }
    },

    restrictChars(event) {
      if (event.charCode === 32 && !this.firstName.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },

    restrictChars1(event) {
      if (event.charCode === 32 && !this.lastName.length) {
        event.preventDefault()
      } else {
        if (
          (event.charCode >= 65 && event.charCode <= 90) ||
          (event.charCode >= 97 && event.charCode <= 122) ||
          event.charCode === 32
        ) {
          return true
        } else {
          event.preventDefault()
        }
      }
    },
  },
}
</script>

<template>
  <b-modal
    id="profile-update-modal"
    title="Edit Profile"
    :hide-footer="true"
    @shown="getData"
    @hidden="resetModal"
  >
    <b-overlay :show="show" :opacity="0.6" rounded="sm">
      <b-card>
        <b-alert
          v-model="isadminError"
          variant="danger"
          v-html="adminError"
        ></b-alert>
        <b-alert
          v-model="isSuccess"
          variant="success"
          v-html="adminSuccess"
        ></b-alert>
        <b-form @submit.prevent="saveProfile">
          <center
            ><img
              v-if="data.profilePic"
              :src="AWSUrl + data.profilePic"
              style="width: 150px; height: 150px; margin: auto"
          /></center>
          <br />
          <b-form-group
            label="Update Profile Image(Max Size: 3MB)"
            label-for="input-1"
          >
            <b-form-file
              id="file"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Update Profile..."
              @change="uploadImage"
            ></b-form-file>
          </b-form-group>
          <p v-if="sizeError" style="color: red"
            >Please upload file less than 3 MB</p
          >
          <p v-if="validTypeError" style="color: red"
            >Please upload only jpg, png file</p
          >
          <b-form-group label="First Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="firstName"
              type="text"
              @keypress="restrictChars($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Last Name" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="lastName"
              type="text"
              @keypress="restrictChars1($event)"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Email" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="data.email"
              type="text"
              disabled
              style="cursor: not-allowed; background: #e0d9d9"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Phone" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="phone"
              type="text"
              disabled
              style="cursor: not-allowed; background: #e0d9d9"
            ></b-form-input>
          </b-form-group>

          <b-form-group label="Select State" label-for="input-2">
            <b-form-select
              v-model="state"
              parsley-trigger="change"
              @change="selectCity"
            >
              <b-select-option :value="null" disabled
                >Select State</b-select-option
              >
              <b-select-option
                v-for="index in stateList"
                :key="`index${index}`"
                :value="index"
                >{{ index }}</b-select-option
              >
            </b-form-select>
          </b-form-group>

          <b-form-group label="Select City" label-for="input-2">
            <b-form-select v-model="city" parsley-trigger="change">
              <b-select-option :value="null" disabled
                >Select City</b-select-option
              >
              <b-select-option
                v-for="index in cityList"
                :key="`index${index}`"
                :value="index"
                >{{ index }}</b-select-option
              >
            </b-form-select>
          </b-form-group>

          <b-form-group id="button-group" class="mt-4">
            <b-button v-if="!isLoading" type="submit" variant="primary"
              >Update</b-button
            >
            <b-button
              v-else
              type="submit"
              variant="primary"
              class="btn-block"
              disabled
            >
              <b-spinner small></b-spinner>Loading...
            </b-button>
          </b-form-group>
        </b-form>
      </b-card>
    </b-overlay>
  </b-modal>
</template>
